import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getLeaveTypeName(type) {
  const names = {
    sick_leave: 'Sick Leave',
    casual_leave: 'Casual Leave',
    vacation: 'Vacation',
    maternity_leave: 'Maternity Leave',
    paternity_leave: 'Paternity Leave',
    unpaid_leave: 'Unpaid Leave'
  };
  return names[type] || type;
}

export function getStatusBadge(status) {
  const badges = {
    pending: 'bg-amber-50 text-amber-700 border-amber-200',
    approved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    rejected: 'bg-red-50 text-red-700 border-red-200',
    cancelled: 'bg-slate-50 text-slate-600 border-slate-200'
  };
  return badges[status] || badges.pending;
}
